<template>
    <v-container class="pa-0" >             
        <v-row class="ma-0" justify="center" v-if="otherData">
            <v-col class="pa-0" lg="2" md="4" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="green">mdi-cash-check</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Credito</v-list-item-title>
                            <v-list-item-subtitle>{{ credit | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col class="pa-0" lg="3" md="3" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-cash-remove</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Debito</v-list-item-title>
                            <v-list-item-subtitle>{{ debit | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col class="pa-0" lg="3" md="3" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="red">mdi-cash-clock</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Insoluto ({{ expiredPercentage }}%)</v-list-item-title>
                            <v-list-item-subtitle>{{ creditExpired | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col class="pa-0" lg="3" md="3" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon :color="total > 0 ? 'green' : 'red'">mdi-cash-multiple</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Saldo</v-list-item-title>
                            <v-list-item-subtitle>{{ total | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col class="pa-0" lg="3" md="3" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="grey">mdi-check-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Chiuse</v-list-item-title>
                            <v-list-item-subtitle>{{ closed | currency(2) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
        </v-row>
    </v-container>
</template>

<script>

    export default {
        name: 'deadlines-footer',
        props: {
            items: Array,
            fieldsset: Array,
            otherData: Object,
        },

        data() {
            return {
            }
        },

        computed: {
            credit() {
                return this.otherData.credit 
            },

            debit() {
                return this.otherData.debit 
            },

            creditExpired() {
                return this.otherData.credit_expired 
            },
                
            // saldo netto: credito meno debito (note di credito ed eccedenze
            // stanno nel debito lato clienti e nel credito lato fornitori)
            total() {
                return this.otherData.credit - this.otherData.debit 
            },

            closed() {
                return this.otherData.closed || 0
            },

            expiredPercentage() {
                // Calcola la percentuale di insoluti sul totale dei crediti (aperti + chiusi)
                const totalCredits = this.credit + this.closed
                if (totalCredits === 0) return 0
                return ((this.creditExpired / totalCredits) * 100).toFixed(1)
            }
        },
    }
</script>